import { SecondaryButton, PrimaryButton } from '../forms/buttons';

const CancelConfirmation = ({
    isOpen,
    onKeepEditing,
    onConfirmCancel,
    title = "Confirm Cancel",
    message = "You have unsaved data entries. Are you sure you want to cancel? All entered data will be lost."
}) => {
    if (!isOpen) return null;

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            onKeepEditing();
        }
    };

    return (
        <div className="confirm-popup show"
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 10000
            }}
            onClick={handleOverlayClick}
        >
            <div className="popup-content" style={{
                backgroundColor: '#fff',
                padding: '30px',
                borderRadius: '8px',
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.5)',
                minWidth: '400px',
                maxWidth: '90%',
                textAlign: 'center'
            }}>
                <h3 style={{
                    marginTop: 0,
                    marginBottom: '15px',
                    color: '#333',
                    fontSize: '20px',
                    fontWeight: 600
                }}>
                    {title}
                </h3>
                <p style={{
                    marginBottom: '25px',
                    fontSize: '16px',
                    lineHeight: 1.5,
                    color: '#555'
                }}>
                    {message}
                </p>
                <div className="popup-buttons" style={{
                    marginTop: '25px',
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '15px'
                }}>
                    <SecondaryButton onClick={onKeepEditing} buttonText="Keep Editing" />
                    <PrimaryButton onClick={onConfirmCancel} buttonText="Yes, Cancel" />
                </div>
            </div>
        </div>
    );
};

export default CancelConfirmation;